const EnglishTerms = () => (
  <>
    <section>
      <h2 className="regular-text">א. קניין רוחני</h2>
      <ul className="regular-text">
        <li>
          The website and all its contents are protected by intellectual property laws,
          including copyright and trademark laws. These contents include, for example,
          texts, images, illustrations, videos, sound clips (audio), software applications, etc.,
          as well as the protected trade names Campus IL and other symbols.
        </li>
        <li>
          All rights in the website and in the materials found on it are reserved to their
          owners - which is the Digital Israel Headquarters or third parties who have allowed
          the Digital Israel Headquarters to all of them on the website.
        </li>
        <li>
          משתמש באתר הסבור כי מופיע בו חומר שאין להציגו מכל סיבה שהיא,
          מתבקש לפנות לאתר באמצעות שליחת דוא"ל לכתובת <a className="link-style black-color" href="mailto:support@campus.gov.il">support@campus.gov.il</a> והחומר יוסר ככל שפנייתו תמצא מוצדקת.
        </li>
        <li>
          השימוש באתר ובתכנים הנמצאים בו מותר על פי תנאי "שימוש הוגן"
          כמובנו בסעיף 19 לחוק זכות יוצרים, התשס"ח-2007. לפיכך,
          מותר לך לעשות באתר ובחומרים שימוש למטרות לימוד עצמי,
          מחקר, ביקורת, סקירה, דיווח עיתונאי, הבאת מובאות ("ציטוטים"),
          או הוראה ובחינה על ידי מוסד חינוך ובלבד שהשימוש בהם
          ייעשה בהגינות מבחינת מטרת השימוש ואופיו; אופי היצירה שבה נעשה השימוש;
          היקף השימוש ביחס ליצירה בשלמותה והשפעת השימוש על ערכה של היצירה.
          בנוסף, בעת שימוש בחומרים נדרש להקפיד על מתן ייחוס הולם
          (קרדיט) ליוצר היצירה ולהימנע מלנקוט בכל פעולה פוגענית ביחס ליצירה,
          ככל שיש בה כדי לפגוע בכבודו או בשמו של היוצר.
        </li>
        <li>
          מעבר לכך, חל איסור מוחלט לעשות כל שימוש אחר בחומרים, לרבות העתקה, הפצה, שיתוף,
          עריכת שינויים וכיוצא באלה, וזאת ללא קבלת הרשאה מראש ובכתב מאת מטה ישראל דיגיטלית.
        </li>
        <li>
          In cases where there is more use of materials under an
          "open license" - this will be explicitly stated and the use of 
          the materials will be subject to the terms of this license.
        </li>
        <li>
          A user who uploads materials, information and comments to the website hereby grants
          Israel Digital Headquarters free and full permission, without compensation,
          to make use of them himself, or through others, in any form, media and format.
        </li>
      </ul>
    </section>
    <section>
      <h2 className="regular-text">ב. קישורים לאתרים חיצוניים</h2>
      <ul className="regular-text">
        <li>
          The website may contain links that point to websites external to the website.
          These were created for the user's convenience, but are not under the
          control of Digital Israel Headquarters and Digital Israel Headquarters
          is not responsible in any way for the content that appears in them, so these links should not be
          considered as an endorsement by Digital Israel Headquarters of what is said in them.
          It will be clarified that this does not detract from the fact that sometimes the course staff will refer
          to the content on the external website as part of the course.
        </li>
        <li>
          משתמש באתר הסבור כי קישור לתוכן או אתר חיצוני אינו ראוי/תקין מכל סיבה שהיא,
          מתבקש לפנות לאתר באמצעות דוא"ל לכתובת <a className="link-style black-color" href="mailto:support@campus.gov.il">support@campus.gov.il</a> והקישור יתוקן/יוסר ככל שפנייתו תמצא מוצדקת.
        </li>
      </ul>
    </section>
    <section>
      <h2 className="regular-text">ג. אבטחת מידע והגנת הסייבר</h2>
      <ul className="regular-text">
        <li>
          As you know, the internet is exposed to various risks of intrusion into databases,
          copying or changing of information appearing in them, online frauds such as "phishing"
          (extraction of information by hostile parties impersonating an authorized party) and the like.
        </li>
        <li>
          The Digital Israel Headquarters takes advanced measures to secure the
          information stored on the website and the services provided through it,
          among other things by requiring the identification of the Digital Israel Headquarters
          (as will be detailed below) or by requiring the identification of
          third parties authorized by the Digital Israel Headquarters, but naturally,
          it cannot prevent absolutely the realization of all said risks. Therefore,
          the user of the website hereby releases the Digital Israel Headquarters and anyone on its behalf,
          from any responsibility for any damage, loss or expense that may be incurred, directly or indirectly,
          during the use of the website or as a result of the use of it and its contents.
        </li>
        <li>
          It is the user's responsibility to keep his identification details confidential on the website,
          as well as to act vigilantly and carefully, for example, in relation to "phishing" messages,
          which may be sent, allegedly, in the name of Digital Israel Headquarters.
          Meanwhile, Digital Israel Headquarters recommends using additional security measures for the
          computer's operating system and appropriate software,
          as well as refraining from using the identified services on the website using public computers and networks.
        </li>
      </ul>
    </section>
    <section>
      <h2 className="regular-text">ד. מדיניות הפרטיות</h2>
      <div>
        <h3 className="regular-text">זיהוי המשתמש</h3>
        <ul className="regular-text">
          <li>
            מרבית השירותים באתר מחייבים הזדהות של המשתמש באמצעות הרשמה
            לאתר בתהליך חד-פעמי, במסגרתו נדרש למסור פרטים מזהים.
            בתום הליך ההרשמה, יבחר המשתמש בסיסמה, באמצעותה תאומת זהותו בכל פעם שיבקש לקבל מהאתר שירותים מזוהים.
            שם המשתמש והסיסמה שיבחרו על ידי המשתמש הם אישיים ואין להעבירם או לגלותם לאחר.
          </li>
          <li>
            בכל שימוש בשירותים המזוהים, יישלחו למשתמש הרשום הודעת דואר אלקטרוני או מסרון,
            לפי פרטי ההתקשרות שמסר, המודיעים לו על שימוש זה.
            במקרה בו קיבל המשתמש הודעה שכזו, מבלי שעשה שימוש באתר,
            או בכל מקרה של חשש לפגיעה בפרטיות וסודיות
            המשתמש באתר, יש לשלוח באופן מיידי הודעה לכתובת – <a className="link-style black-color" href="mailto:support@campus.gov.il">support@campus.gov.il</a>.
          </li>
          <li>
            המשתמש רשאי למחוק את פרטי הזיהוי שלו ממערכת ההזדהות של האתר או לחדשם בכל עת,
            ואולם מטה ישראל דיגיטלית רשאי לשמור עותק מנתוני הזיהוי לצורכי תיעוד במאגר נפרד ממערכת ההזדהות. יצוין,
            כי מחיקה של פרטי הזיהוי של המשתמש מקורס מסוים ניתנת לביצוע על ידי המשתמש עצמו,
            בעוד שמחיקת פרטי הזיהוי של המשתמש מהפלטפורמה דורשת פנייה למוקד התמיכה הטכנית של קמפוס
            IL באחד מערוצי התקשורת המפורטים בדף התמיכה שבאתר.
          </li>
        </ul>
      </div>
      <div>
        <h3 className="regular-text">איסוף, שמירה ושימוש במידע</h3>
        <ul className="regular-text">
          <li>
            לשם הרשמה לאתר יידרש המשתמש לספק מידע אישי הכולל: שם מלא;
            כינוי וכתובת דוא"ל וכן למסור מידע נוסף כגון גיל, מגדר, מקום מגורים והשכלה.
          </li>
          <li>
            לשם מתן שירותים בתשלום, במקרה של הרשמה לקורס תעודה בתשלום, ייאספו ויישמרו פרטי התשלום של המשתמש.
          </li>
        </ul>
      </div>
      <div>
        <h3 className="regular-text">כלים טכנולוגיים לאיסוף מידע – כללי</h3>
        <ul className="regular-text">
          <li>
            מטה ישראל דיגיטלית עושה שימוש בכלים טכנולוגיים
            מקובלים של צדדים שלישיים לצורך איסוף מידע אישי ומידע אנונימי, כדוגמת cookies “Google” analytics
            ,תגי אינטרנט וטכנולוגית Facebook © pixel, וזאת בין היתר לצורך ניתוח נתונים סטטיסטיים אודות השימוש
            באתרולצורך שיפור חוויית גלישת המשתמש.
            כך למשל נאסף מידע כגון מידע על ביצועי תלמידים, דפוסי למידה, ונתונים אודות היסטוריית
            הגלישה של המשתמש באתר לצורך תחזוקה וניהול יעיל של האתר.
            בהפעלת כלים אלו באתר, החברות המספקות את הכלים (למשל Google ו- Facebook)
            עושות שימוש ב- cookies שלהן לזיהוי מכשירך ולאיסוף מידע כגון
            כתובת ה IP שלך, מזהים ייחודיים למכשיר ממנו הנך גולש ומאפייניו, פעילותך באתר והעמודים בהם צפית ועוד.
            ה- cookies עשויים לאפשר להן לזהות את מכשירך אף לאחר היציאה מאתר קמפוסIL.
            המידע הנאסף על ידן עשוי להישמר במאגרי המידע של החברות מחוץ לישראל.
            לעניין זה  ניתן  לעיין בתנאי השימוש של אותם צדדים שלישיים
          </li>
        </ul>
      </div>
      <div>
        <h3 className="regular-text">לעניין שירותי Google Analytics -</h3>
        <ul className="regular-text">
          <li>
            עוגיות צד שלישי אשר בעזרתן האתר עשוי לתעד את כתובת ה-IP,
            מערכת ההפעלה ותוכנת הדפדפן בה נעשה שימוש באתר וביכולתו לזהות מכתובת ה-IP
            את זהות ספק האינטרנט והמיקום הגאוגרפי של נקודת ההתקשרות של המשתמש.
            חלק מהמידע באתר נאסף באמצעות קבצי
            Cookies (קבצי טקסט קטנים המוכנסים למחשב ומתעדים מידע על המשתמש, שאליו האתר יכול לגשת),
            וזאת בתלוי בנכונות המשתמש לאפשר קבלת קבצים מסוג אלה באמצעות הגדרות דפדפן הגלישה באתר.
          </li>
          <li>
            עם זאת, מובהר כי דחיית קבלת קבצי ה-Cookies הנשלחים מהאתר עלולה לפגוע בתפקוד חלקים וכלי עזר הפועלים באתר.
          </li>
        </ul>
      </div>
      <div>
        <h3 className="regular-text">איסוף מידע מרשתות חברתיות –</h3>
        <ul className="regular-text">
          <li>
            כאמור, באתר נעשה שימוש בעוגיות צד שלישי Facebook Pixel המותקנות על ידי צדדים שלישיים שבעזרתם האתר עשוי
            לאסוף מידע מסוים לשם מחקר התנהגות ודמוגרפיה, לצורך פרסום מותאם ברשתות המדיה.
            האתר יקבל מידע אודות המשתמש לרבות פרטים, תמונות,
            תמונת פרופיל, טווח גילאים, מין, כתובת דואר אלקטרונית ומספר מזהה (הניתן לכל משתמש),
            מזהים ייחודיים למכשיר ממנו המשתמש גולש ומאפייניו,
            פעילות באתר לרבות העמודים בהם המשתמש צפה ומידע נוסף בהתאם להסכמות שבין המשתמש ובין אתרי הרשתות החברתיות.
            המידע שייאסף יהיה זמין רק לחשבון הפרסום של אתר קמפוסIL.
            ביכולת המשתמש לשלוט בעוגיות הללו באמצעות הגדרות הדפדפן שברשותך.
          </li>
          <li>
            לפרטים נוספים בעניין זה יש לעיין בתנאי השימוש של Google ושל Facebook.
          </li>
          <li>
            בהסכמתך לתנאי מדיניות פרטיות זו ולתנאי השירותים המפורטים בה,
            הנך מסכים לשימוש בטכנולוגיות המתוארות ובטכנולוגיות אחרות,
            כפי שיהיו מעת לעת עבור מטרות דומות,
            לרבות שימוש במידע שייאגר באמצעותן לצורך זיהוי ו/או אפיון של המשתמש על פיהן.
          </li>
          <li>
            יובהר כי באפשרותך בכל עת גם לעדכן או לשנות את הגדרות מכשירך/מחשבך ולחסום באופן גורף או חלקי את השימוש בקובצי
            Cookies שונים ו/או בהרשאות אחרות המתבקשות על-ידי שירותים מקוונים ודיגיטליים שבשימושך.
            במקרה כזה, ייתכן כי שירותים מסוימים, כולם או חלקם,
            לא ייפעלו כראוי (לדוגמה, ייתכן כי זיהוי אוטומטי, העדפות שימוש או שפה לדוגמה לא ישמרו).
            שינוי הגדרות מכשירך כאמור הינו באחריותך בלבד. כמו כן, תוכל אף להסיר עצמך משימוש ב- Google analytics
            ובשירותי צד ג\' אחרים כמפורט לעיל, על-פי תנאיהם, ולהגדיר מחדש ולשלוט בפרסום המופנה אליך מגוגל,
            פייסבוק ואחרים דרך הגדרות המשתמש שלך ישירות באתריהם.
            לדוגמה, באתר הפייסבוק שלך, תוכל לגשת להגדרות הפרופיל שלך:
            – הגדרות ופרטיות – הגדרות – המידע שלך בפייסבוק – פעילות מחוץ לפייסבוק
            (שם תוכל לנהל את המידע המשותף של פייסבוק ושל לקוחותיה העסקיים, לפי בחירתך).
          </li>
          <li>
            איסוף ושמירה של מידע באמצעות האתר ייעשה, ככלל, למטרות הבאות: לצורך זיהוי המשתמש
            ואימות זהותו בעת הכניסה לאתר ובעת ביצוע תשלום או החזר תשלום;
            על מנת לאפשר למטה ישראל דיגיטלית ולמוסדות החינוך לשפר את חוויית המשתמש באתר,
            לייעל ולשפר את נגישות השירותים שהוא מספק למשתמש;
            לצורכי מחקר מדעי, ובייחוד לצורכי מחקר חינוך;
            על מנת לנתח באופן סטטיסטי את ביצועי המשתמשים ולנהל מעקב אחר נתוני נוכחותם,
            התקדמותם והשלמתם קורסים מקוונים במטרה לשפר את הקורס המקוון;
            על מנת לנטר ולזהות ניצול לרעה של האתר; על מנת לשפר את האתר, על מערכותיו ואבטחתו.
          </li>
          <li>
            למען הסר ספק, המשתמש נותן בזאת הסכמתו לאיסוף,
            שימור ופרסום של מידע ונתונים כמותיים הנאספים
            לגביו לרבות באמצעות עוגיות צד שלישי, בדגש על שירותי Google Analytics וכן Facebook Pixel.
          </li>
          <li>
            מידע אישי שנמסר לאתר יישמר בהתאם להוראות כל דין,
            לרבות חוק הגנת הפרטיות, התשמ"א-1981 ותקנות הגנת הפרטיות (אבטחת מידע), תשע"ז-2017
          </li>
        </ul>
      </div>
      <div>
        <h3 className="regular-text">איסוף מידע בתהליך היבחנות מרחוק</h3>
        <ul className="regular-text">
          <li>
            קיימת אפשרות כי לצורך קבלת תעודה מאומתת בסיום קורס דיגיטלי בפלטפורמה הלאומית,
            המשתמש ידרש לעבור בחינה אשר תתקיים "מרחוק", כלומר באמצעות אמצעי אלקטרוני,
            כגון מחשב, ושלא תחת פיקוח פיסי של בוחנים מטעם מטה ישראל דיגיטלית
          </li>
          <li>
            במקרים אלו, לשם השתתפות בבחינה "מרחוק" לצורך קבלת תעודה מאומתת,
            המשתמש יתבקש לתת הסכמתו למטה ישראל דיגיטלית ו/או לצד ג\'
            מטעמו לעשות שימוש בכלים טכנולוגיים ואחרים אשר מטרתם לשמור על טוהר הבחינות והשוויון בין הנבחנים.
            כלים אלו יכולים להיות, למשל, שיתוף מסך המחשב שלך בעת הבחינה;
            הקלטת מהלך הבחינה באמצעות מצלמה (לרבות זיהוי פני הנבחן);
            הקלטת שמע של סביבת הבחינה (לרבות זיהוי קול הנבחן);
            הקלטת פעילות הגלישה ברשת בזמן הבחינה או אמצעים דומים אחרים.
          </li>
          <li>
            קיימת אפשרות כי לצורך שימוש בכלים אלה, תדרש לאפשר התקנה של יישומים ייעודיים במחשבך האישי.
          </li>
          <li>
            המידע שייקלט וייאסף תוך שימוש בכלים אלו יישמר בשרתי מטה ישראל דיגיטלית
            ויעשה בו שימוש על מנת להבטיח את טוהר הבחינות ואת השוויון בין הנבחנים.
          </li>
        </ul>
      </div>
      <div>
        <h3 className="regular-text">שיתוף מידע עם צדדים שלישיים</h3>
        <ul className="regular-text">
          <li>
            האתר והמידע שבו מאוחסנים בחוות השרתים (AWS) של חברת Amazon בישראל ובמדינה באיחוד האירופאי,
            וככאלה הם כפופים למדיניות הפרטיות ולתנאי השימוש של AWS המופיעים <a className="link-style black-color" href="https://aws.amazon.com/privacy/" target="_blank" rel="noreferrer">כאן</a>.
          </li>
          <li>
            בנוסף, האתר מנוהל על ידי חברה עמה התקשר מטה ישראל דיגיטלית (חברת א.מ.ת מיחשוב בע"מ),
            המחויבת בשמירה על אבטחת המידע, והמנועה, על פי התחייבותה כלפי מטה ישראל דיגיטלית,
            מלעשות שימוש במידע, אלא ככל שהדבר נדרש לשם מילוי תפקידה או על פי הדין.
          </li>
          <li>
            מעבר לכך, מטה ישראל דיגיטלית שומר לעצמו את הזכות
            לשתף את המידע והנתונים שיימסרו או שייאספו אצלו עם גורמים שלישיים המציעים קורסים באמצעות האתר,
            בהם מוסדות חינוך ומוסדות השכלה גבוהה.
          </li>
          <li>
            שיתוף המידע ייעשה בהתאם למטרות שפורטו לעיל, תוך דרישה מהצדדים השלישיים
            להגן על המידע באופן דומה לאופן ההגנה הננקט על ידי מטה ישראל דיגיטלית.
          </li>
          <li>
            מידע המתקבל באמצעות האתר לשם קבלת שירותים יכול שיועבר גם לספקי שירות בישראל ומחוצה לה,
            שמבצעים פעולות מסוימות בשם מטה ישראל דיגיטלית או המוסד האקדמי,
            כולל עיבוד מידע שסיפק המשתמש באתר, עיבוד רכישות ועסקאות אחרות באתר דרך ספקי צד ג\',
            הפעלת האתר או חלקים ממנו, אספקת קורסים או ניהולם.
            על ספקים אלה חלה חובה לשמור על סודיות המידע בהתאם לדין הנוהג.
          </li>
        </ul>
      </div>
      <div>
        <h3 className="regular-text">שיתוף מידע עם צדדים שלישיים ייעשה בתנאים הבאים:</h3>
        <ol className="regular-text">
          <li>
            מידע ישותף עם ספקים וגופים אשר נמצאים בהתקשרות מכוח הסכם או מכרז או קול קורא עם מטה ישראל דיגיטלית
            לצורך הפעלת היבט מסוים באתר. כך למשל,
            בכל הנוגע לקורס "<a className="link-style black-color" href="https://campus.gov.il/course/mse-gov-psychometry-he/" target="_blank" rel="noreferrer">הפסיכומטרי של המדינה</a>" אשר קיים באתר, משותף מידע,
            ביחס לביצוע תרגולים, צפייה בסרטונים ותוכן חיבורים לדוגמה, עם מפעיל הקורס.
          </li>
          <li>
            מידע ישותף עם מבקרים אחרים באתר, במידה והמשתמש יבחר לפרסם תגובות,
            שיעורי בית או כל מידע שהוא באזורים באתר המיועדים לתקשורת ציבורית.
          </li>
          <li>
            מידע שהמשתמש מפרסם באזורים באתר שיועדו לעיונם של חברי
            קבוצת הלמידה בהווה או בקבוצות למידה עתידיות, ישותף עם משתמשים נוספים אלה.
          </li>
          <li>
            לצרכי מחקר מדעי שאינו מבוצע על ידי גורם שלישי המציע קורס באתר, ובלבד שהמידע הינו מותמם.
          </li>
          <li>
            על מנת לקשר בין משתמשים למטרות לימודיות.
          </li>
          <li>
            בתגובה לזימון לבית דין או לצו בית משפט, או עבור כל הליך חוקי אחר;
            על מנת לחקור, או להתגונן בפני חקירה, או על מנת לפעול בתגובה לפעילויות בלתי-חוקיות, חשד להונאה;
            לאור בעיות אבטחה או בעיות טכניות;
            על מנת לאכוף את תנאי השימוש באתר, על מנת להגן על זכויות מטה ישראל דיגיטלית,
            רכושו או בטחונו של מטה ישראל דיגיטלית או של אחרים.
          </li>
          <li>
            עם גורמים שעשויים להחליף, באופן מלא או חלקי, את מטה ישראל דיגיטלית בניהול האתר או חלקים ממנו.
          </li>
          <li>
            למטרת גביית כספים בהתאם לפרטי החיוב שימסרו, ככל שמדובר בקורס בתשלום.
          </li>
          <li>
            לצורך אינטגרציה עם שירותי צד ג'.
            כך לדוגמא, לעניין סרטונים ותכנים נוספים שיועלו על גבי אתר YouTube או בשירותי רשת
            (כגון מחולל כתיבת קוד תוכנה), באתרים אחרים שאינם בשליטת מטה ישראל דיגיטלית.
          </li>
        </ol>
      </div>
    </section>
    <section>
      <div>
        <h2 className="regular-text">ה. כללי התנהגות בסביבה המקוונת</h2>
        <ul className="regular-text">
          <li>
            על האתר חלים דיני מדינת ישראל, ובמקרים מסוימים גם דינים החלים על העברת מידע מחוץ לגבולות המדינה.
          </li>
          <li>
            משתמש המעלה חומר, מידע או תגובה מכל סוג שהיא לאתר נושא באחריות מלאה למעשיו.
          </li>
          <li>
            מבלי לגרוע מכלליות האמור, חל איסור מוחלט להעלות תכנים הפוגעים בשמם הטוב של אחרים;
            חומרים המטרידים או מאיימים על אחרים;
            חומרים העוסקים בפעילות בלתי-חוקית; חומרים המפרים את קניינו הרוחני של אחר;
            חומרים מבזים, פורנוגרפיים, בוטים, לא מכבדים או בלתי חוקיים; חומרים הכוללים דברי פרסומת או שידול מסחרי;
            חומרים הקשורים לפעילות פוליטית מפלגתית וכל חומר הכולל,
            במכוון, מידע מטעה או בלתי מדויק המועלה בכוונה להטעות אחרים.
          </li>
          <li>
            חל על המשתמש איסור מוחלט לעשות שימוש באתר ובשירותים הניתנים בו לרעה,
            לרבות בדרך של שיבוש או הכבדה על השירותים הניתנים באתר,
            יצירת גישה אליהם מרחוק, בכל אמצעי שהוא, העתקה של חומרים מהאתר באמצעים טכנולוגיים או אחרים וכיו"ב.
            כמו כן, חל איסור על הפרעה לשימוש או הנאה של משתמש אחר באתר
            או על כניסה בלתי מורשית לאתר או לחשבונות משתמשים אחרים בו.
          </li>
        </ul>
      </div>
    </section>
    <section>
      <h2 className="regular-text">ו. אחריות</h2>
      <ul className="regular-text">
        <li>
          השירות המוצע למשתמשים באתר הוא "כמות שהוא" ("AS IS").
        </li>
        <li>
          מטה ישראל דיגיטלית לא יישא באחריות להתאמת השירותים הניתנים במסגרת האתר לצרכי המשתמש,
          כמו כן לא יישא באחריות לטעויות או לחסרים בחומרים או במידע המוצג באתר.
          בכלל כך לא יישא מטה ישראל דיגיטלית באחריות לכל נזק או הוצאה שנגרמו למשתמש
          או לכל צד ג' כתוצאה ישירה או עקיפה מן השימוש באתר,
          לרבות נזק שנגרם עקב השימוש ביישומי תוכנה שהורדו ישירות באמצעות האתר
          או הופעלו כתוצאה מהשימוש באתר במישרין או בעקיפין.
        </li>
        <li>
          מטה ישראל דיגיטלית לא יישא באחריות לשינויים שנעשו בחומר המוצג באתר, על ידי המשתמש או על ידי כל צד ג'.
        </li>
        <li>
          למטה ישראל דיגיטלית הזכות, לפי שיקול דעתו,
          לערוך ביקורת ביחס לפרסומים מכל סוג שהוא אשר יועלו לאתר, על ידי משתמשים או על ידי כל גורם אחר,
          באמצעות עריכתם או הסרתם – כולם או חלקם – מכל סיבה שהיא, וזאת מבלי להודיע על כך מראש או בדיעבד לגורם המפרסם.
        </li>
      </ul>
    </section>
    <section>
      <h2 className="regular-text">ז. תעודות</h2>
      <ul className="regular-text">
        <li>
          מטה ישראל דיגיטלית, משרדי הממשלה,
          המוסדות האקדמיים וארגונים אחרים המציעים קורסים באתר רשאים להעניק תעודת סיום או הכרה מסוג אחר
          ("תעודה") למשתמשים אשר, להערכתם, הציגו שליטה מספקת בתכני הקורס המועבר.
          ההחלטה בדבר הענקת תעודה למשתמש בקורס מסוים מצויה בשיקול דעתו
          הבלעדי של הגוף המציע את הקורס אך עשויה להיות כפופה לקבלת אישור קמפוס IL.
          קמפוס IL או הגופים המספקים קורסים באתר רשאים לבחור שלא להעניק תעודה בגין קורסים מסוימים.
          במקרים אלה, ייתכן כי תעודות יונפקו על ידי קמפוסIL , בצירוף שמו של הגוף שהעלה את הקורס.
        </li>
        <li>
          יתכן והמשתמש יידרש לשלם תשלום ייעודי לצורך קבלת תעודת סיום מאומתת.
        </li>
        <li>
          היותו של משתמש תלמיד באחד או יותר מהקורסים בקמפוס IL, או מסיים קורס באחד או יותר מהקורסים בקמפוס IL,
          אינה מקנה למשתמש זכות כלשהי כלפי הגוף שהעלה את הקורס
          ולא תהא למשתמש זכות לעשות שימוש באלו ממשאבי הגוף שהעלה את הקורס או באלו ממשאבי קמפוס IL
          מעבר להשתתפות בקורסים המקוונים המוצעים באתר,
          וכן לא תהא למשתמש זכות לקבל הטבות או זכויות-יתר הניתנות לתלמידים הרשומים לגוף שהעלה את הקורס, ככל שישנן.
        </li>
      </ul>
    </section>
    <section>
      <h2 className="regular-text">ח. שונות</h2>
      <ul className="regular-text">
        <li>
          מדינת ישראל המיוצגת בהסכם זה על ידי "מטה ישראל דיגיטלית" כהגדרתו לעיל, כוללת את כל עובדיה ונציגיה.
        </li>
        <li>
          במידה ותימצא סתירה או אי-התאמה בין חומר המתפרסם באתר לבין חומר המופיע בפרסומים
          רשמיים בכתב של מדינת ישראל, החומר בפרסומים רשמיים אלה ייחשב כנכון ויגבר.
          בכל מקרה של סתירה או אי התאמה בין חומר המוצג באתר לבין פרסום אחר של מטה ישראל דיגיטלית,
          יקבע מטה ישראל דיגיטלית איזה מן הפרסומים ייחשב כנכון.
        </li>
        <li>
          מטה ישראל דיגיטלית רשאי לשנות את תנאי השימוש באתר בכל עת, כאשר כל שינוי כזה ייכנס לתוקף מיידית עם הצגתו באתר.
        </li>
        <li>
          מטה ישראל דיגיטלית רשאי להשעות, להפסיק או להימנע מלספק גישה לאתר
          או לשירותים למשתמש שאינו מציית לתנאי השימוש, כולם או חלקם,
          או אם מטה ישראל דיגיטלית או כל רשות מוסמכת חוקרים חשד להתנהגות המנוגדת לדין או לתנאי השימוש בעת השימוש באתר,
          וזאת על פי שיקול דעתו הבלעדי של מטה ישראל דיגיטלית.
        </li>
        <li>
          בכל פניה או שאלה הנוגעת לפעילות האתר, ניתן לפנות באמצעות כתובת הדוא"ל <a className="link-style black-color" href="mailto:support@campus.gov.il">support@campus.gov.il</a>.
        </li>
        <li>
          סמכות שיפוט: תנאי השימוש באתר וכל טענה או סכסוך הקשורים לתנאי שימוש אלה
          ידונו על פי דיני מדינת ישראל ויכרעו בבית המשפט המוסמך בירושלים בלבד.
        </li>
        <li>
          תנאי השימוש באתר והאתר עצמו מנוסחים בלשון זכר מטעמי נוחות, אך מתייחסים לגברים ונשים כאחד.
        </li>
        <li>
          מטה ישראל דיגיטלית מאחל לכם חוויה פוריה, מאתגרת ומהנה מלימודיכם המקוונים.
        </li>
      </ul>
    </section>
  </>
);

export default EnglishTerms;
